export const MESSAGE_CAPTURE = 'message-capture';
export const MESSAGE_RESET = 'message-reset';

export function capture(payload, threadId) {
  return { type: MESSAGE_CAPTURE, payload, threadId };
}

export function reset(payload, threadId) {
  return { type: MESSAGE_RESET, payload, threadId };
}



// WEBPACK FOOTER //
// ./src/redux/actions/messageFormAction.jsx